/* eslint-disable jsx-a11y/no-redundant-roles */
import * as React from "react";

import Radio from "../../Radio";
import Clear from "../../Clear";
import "./style.less";

const {
  DIRECTORY_THEME
} = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/staticTextMaps/checkout`);

const $ST = DIRECTORY_THEME.ADDRESS_ITEM;
const $AF = DIRECTORY_THEME.ADDRESS_FORM;

export default class AddressItem extends React.Component {
  render() {
    const { address, current, onSet, type, onEdit, onDeleteAddress } =
      this.props;

    const initialClassName = "checkout-address__item";
    let wrapperClassName = initialClassName;

    if (current) {
      wrapperClassName += " tfs-checkout-address__item--selected";
    }
    wrapperClassName += " tfs-checkout-address__item";

    function renderStreet() {
      if (address && address.district && address.district.name) {
        return <span>{address.district.name}</span>;
      }
    }
    function renderHomeNo() {
      if (address && address.line) {
        const formattedLine = address.line
          .split($AF.SEPERATOR)
          .join($AF.CONCATENATOR);
        return <span> {formattedLine ? formattedLine : address.line}</span>;
      }
    }
    function renderCityName() {
      let str;
      if (address && address.city && address.city.name) {
        str = address.city.name;
      }
      if (address && address.township && address.township.name) {
        str = `${str} ${address.township.name}`;
      }
      return <p>{str}</p>;
    }

    function renderCountry() {
      if (address && address.country && address.country.name) {
        return <p>{address.country.name}</p>;
      }
    }

    function renderAddressTitle() {
      return (
        <p>
          <strong>{address.title}</strong>
        </p>
      );
    }

    function actionButton(title, onClick) {
      return (
        <button
          className="tfs-checkout-address__item__action-btn"
          onClick={onClick}
        >
          {title}
        </button>
      );
    }

    return (
      <div className={wrapperClassName}>
        <label
          className={`pointer ${current ? "selected" : ""}`}
          onClick={(e) => {
            e.preventDefault();
            onSet(address.pk);
          }}
        >
          <div className="checkout-address__item-header">
            <Radio
              name={type}
              value={address.pk}
              checked={current ? true : false}
            />{" "}
            {current && <div>{$ST.SELECTED_ADDRESS}</div>}
            <Clear />
          </div>
        </label>
        <div className="info-container">
          {!current && (
            <div className="icon-wrapper">
              {actionButton($ST.EDIT, () => onEdit(address))}
              {actionButton($ST.DELETE, () => onDeleteAddress(address.pk))}
            </div>
          )}
          <div className="info-wrapper">
            {renderAddressTitle()}
            {renderStreet()}
            {renderHomeNo()}
            {renderCityName()}
            {renderCountry()}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/theme/checkout/tfs/AddressItem.js